import { createElement } from 'src/app/core/helpers/dom';
import { getFontFamily } from 'src/app/project/modules/white-label/white-label-utils/get-font-family';
import { EDashletType } from '../dashlets-enums';
import { getChartName } from './dashboard-export-elements/dashboard-export-chart-name';

export function createDashletHeaderElement({
  accountName,
  workspaceName,
  chartType,
  scale,
  customName,
}: {
  accountName: string;
  workspaceName: string;
  chartType: EDashletType;
  scale: number;
  customName: string;
}): HTMLElement {
  const dashletHeader = createDashletHeader(scale);
  const chartNameElement = createChartNameElement(scale, chartType, customName);
  const selectedRangeElement = createSelectedRangeElement(scale, accountName, workspaceName);

  dashletHeader.appendChild(chartNameElement);
  dashletHeader.appendChild(selectedRangeElement);

  return dashletHeader;
}

function createSelectedRangeElement(
  scale: number,
  accountName: string,
  workspaceName: string,
): HTMLElement {
  const selectedRangeElement = createElement<HTMLElement>('div');

  selectedRangeElement.style.fontSize = `${72 * scale}px`;
  selectedRangeElement.style.lineHeight = `${90 * scale}px`;
  selectedRangeElement.style.color = '#97A3B7';
  selectedRangeElement.style.fontFamily = getFontFamily();
  selectedRangeElement.style.fontWeight = '600';
  selectedRangeElement.style.whiteSpace = 'nowrap';
  selectedRangeElement.style.maxWidth = `${2000 * scale}px`;
  selectedRangeElement.style.overflow = 'hidden';
  selectedRangeElement.style.textOverflow = 'ellipsis';

  selectedRangeElement.textContent = accountName + ' - ' + workspaceName;

  return selectedRangeElement;
}

function createChartNameElement(
  scale: number,
  chartType: EDashletType,
  customName: string,
): HTMLElement {
  const chartNameElement = createElement<HTMLElement>('div');

  chartNameElement.style.fontSize = `${100 * scale}px`;
  chartNameElement.style.lineHeight = `${125 * scale}px`;
  chartNameElement.style.color = '#000000';
  chartNameElement.style.fontFamily = getFontFamily();
  chartNameElement.style.whiteSpace = 'nowrap';
  chartNameElement.style.maxWidth = `${2000 * scale}px`;
  chartNameElement.style.overflow = 'hidden';
  chartNameElement.style.textOverflow = 'ellipsis';
  chartNameElement.style.fontWeight = '400';

  chartNameElement.textContent = getChartName(chartType) + (customName ? ` - ${customName}` : '');

  return chartNameElement;
}

function createDashletHeader(scale: number): HTMLElement {
  const dashletHeader = createElement<HTMLElement>('div');

  dashletHeader.style.position = 'absolute';
  dashletHeader.style.left = '50%';
  dashletHeader.style.transform = 'translateX(-50%)';
  dashletHeader.style.fontFamily = getFontFamily();
  dashletHeader.style.top = `${100 * scale}px`;
  dashletHeader.style.textAlign = 'center';
  return dashletHeader;
}
